export default __webpack_public_path__ + "static/media/Assistance.d5f313c4.png";